<template>
  <div class="mian">
    <div class="nav">
      <Nav title="智能导诊" :fixed="true"></Nav>
      <div class="top"></div>
    </div>
    <div>
      <img
        class="bg_img"
        src="../../assets/Guidance/MMZ.png"
        usemap="#planetmap"
      />
      <map id="planetmap" name="planetmap">
        <area
          shape="rect"
          coords="0,0,450,700"
          alt="The planet Venus"
          class="aaaaa"
          @click="asa"
        />
      </map>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import swtich from "./components/swtich";
export default {
  data() {
    return {
      imgname: "MMZ",
      active: 0,
      tabfalg: true,
      listfalg: false,
      // bg_img: {
      //   height: "90vh",
      //   width: "100%",
      //   backgroundImage:
      //     "url(" + require("../../assets/Guidance/MMZ.png") + ")",
      // },
    };
  },
  components: {
    Nav,
    swtich,
  },
  methods: {
  
    asa(event){
      // console.log('asa', event)
       let date = new Date();
   date.setMinutes(date.getMinutes()+2)
 console.log( date.getFullYear().toString() + this.pad2(date.getMonth() + 1) + this.pad2(date.getDate()) + this.pad2(date.getHours()) + this.pad2(date.getMinutes()) + this.pad2(date.getSeconds()))
    },
     pad2(n){ return n < 10 ? '0' + n : n },
    changelist() {
      this.tabfalg = !this.tabfalg;
    },
  },
};
</script>

<style lang="scss" scoped>
.mian {
  display: flex;
  flex-direction: column;
  max-width: 100vh;
  .aaaaa{
   background-color: red;
  }
  .nav {
    .top {
      height: 35px;
    }
  }
  .headtitle {
    width: 100%;
    text-align: center;
    margin-top: 2vh;
    font-size: 16px;
  }
  .bg_img {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    max-height: 90vh;
    width: 100%;
    background-repeat: no-repeat; //不重复
    background-size: 100% 100%; // 满屏

    .cilik_div {
      width: 20vw;
      height: 8vh;
      border: 1px solid red;
    }
  }
  .bodylist {
    display: flex;
    flex-direction: column;
    max-height: 85vh;
    .van-cell {
      line-height: 36px;
    }
  }
}
</style>